import DodoneContext from 'app/dodones/Context'
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = 'Caboooo acabo', attributes = {} }) => {
  const { finishDodone, updateDodone } = useContext(DodoneContext)

  const onFinish = useCallback(() => {
    finishDodone(attributes)
  })

  return (
    <div className="input-group">
      <ConfirmableSpinnableButton
        className="btn btn-success btn-block"
        onConfirm={onFinish}
        isSpinning={updateDodone.isPending}
      >
        {text}
      </ConfirmableSpinnableButton>
    </div>
  )
}
